<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="用户">
                                <a-input v-model="queryParams.user" placeholder="ID/账号" allow-clear />
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="角色">
                                <a-select
                                    v-model="queryParams.roleId"
                                    placeholder="全部"
                                    allow-clear
                                >
                                    <a-select-option
                                        v-for="role in roleList"
                                        :key="role.id"
                                        :value="role.id"
                                    >{{ role.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
							<span class="x-filter-submit-box">
								<a-button type="primary" @click="getTableData">查询</a-button>
								<a-button style="margin-left: 8px" @click="() => this.queryParams={}">重置</a-button>
							</span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <div class="x-tool">
                <a-button type="primary" icon="plus" @click="add">新增</a-button>
            </div>

            <a-table
                :rowKey="record => record.id"
                :columns="tableColumns"
                :loading="tableLoading"
                :dataSource="tableData"
                :pagination="false"
            >
                <div class="user" slot="user" slot-scope="record">
                    <p>
                        <span>{{ record.loginAccount }}</span>
                        -
                        <span>{{ record.nickname }}</span>
                    </p>
                    <p class="user-extra">
                        <span v-if="record.isSpecial == 'Y'" class="warning" style="margin-right: 5px;">[咪]</span>
                        <span>{{ record.roleName }}</span>
                    </p>
                </div>

                <template slot="online" slot-scope="record">
                    <span class="success" v-if="record.isOnline == 'Y'">是</span>
                    <span v-else>否</span>
                </template>

                <template slot="enable" slot-scope="record">
                    <span v-if="record.isEnable == 'Y'">是</span>
                    <span class="error" v-else>否</span>
                </template>

                <div slot="action" slot-scope="record">
                    <a @click="toggleEnable(record)">
                        {{ record.isEnable === 'Y' ? '禁用' : '启用' }}
                    </a>
                    <template v-if="isShareholder(record)">
                        <a-divider type="vertical" />
                        <a @click="openOddsDrawer(record)">设置赔率</a>
                    </template>
                    <a-divider type="vertical" />
                    <a-dropdown>
                        <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                            更多 <a-icon type="down" />
                        </a>
                        <a-menu slot="overlay">
                            <a-menu-item>
                                <a @click="openTopUp(record)">上分</a>
                            </a-menu-item>
                            <a-menu-item>
                                <a @click="openCashOut(record)">下分</a>
                            </a-menu-item>
                            <a-menu-item>
                                <a @click="openResetPassword(record)">重置密码</a>
                            </a-menu-item>
                            <a-menu-item v-if="record.isSpecial == 'N'">
                                <a @click="toggleSpecial(record)">开启咪牌</a>
                            </a-menu-item>
                            <a-menu-item v-else>
                                <a @click="toggleSpecial(record)">关闭咪牌</a>
                            </a-menu-item>
                            <!--
                            <a-menu-item v-if="isMember(record)">
                                <a @click="confirmDelUser(record)">删除</a>
                            </a-menu-item>
                            -->
                        </a-menu>
                    </a-dropdown>
                </div>
            </a-table>

            <div class="x-pagination">
                <a-pagination
                    :pageSize="pageSize"
                    v-model="pageIndex"
                    :total="totalRow"
                    @change="pageChange"
                    :hideOnSinglePage="true"
                    show-less-items
                />
            </div>

            <user-form-modal
                ref="userForm"
                :visible="userFormVisible"
                :loading="userFormLoading"
                @cancel="userFormCancel"
                @ok="userFormOk"
            />

            <user-top-up-modal
                :visible="topUpVisible"
                :loading="topUpLoading"
                :user="actionUser"
                @cancel="topUpVisible = false"
                @ok="submitTopUp"
            />

            <user-cashout-modal
                :visible="cashOutVisible"
                :loading="cashOutLoading"
                :user="actionUser"
                @cancel="cashOutVisible = false"
                @ok="submitCashOut"
            />

            <user-reset-password-modal
                :visible="resetPasswordVisible"
                :loading="resetPasswordLoading"
                :user="actionUser"
                @cancel="resetPasswordVisible = false"
                @ok="submitResetPassword"
            />

            <user-odds-drawer
                :visible="oddsVisible"
                :user="oddsUser"
                @cancel="oddsVisible = false"
                @ok="oddsVisible = false"
            />
        </a-card>
    </div>
</template>

<script>
import UserFormModal from './UserForm';
import UserTopUpModal from './UserTopUpModal';
import UserCashoutModal from './UserCashoutModal';
import UserResetPasswordModal from './UserResetPasswordModal';
import UserOddsDrawer from './UserOddsDrawer';
import {
    userList,
    userAdd,
    userSetEnable,
    userSetSpecial,
    userDel,
    userRoleList,
    userTopUp,
    userCashOut,
    userResetPassword,
} from '@/api/member/user';

const ROLE_SHAREHOLDER = 1;
const ROLE_MEMBER = 5;

const tableColumns = [
    { title: '#', dataIndex: 'id' },
    { title: '用户', scopedSlots: { customRender: 'user' } },
    { title: '成员', dataIndex: 'memberNum' },
    { title: '累计充值', dataIndex: 'totalRecharge' },
    { title: '累计提现', dataIndex: 'totalCashout' },
    { title: '当前余额', dataIndex: 'balance' },
    { title: '是否在线', scopedSlots: { customRender: 'online' } },
    { title: '是否可用', scopedSlots: { customRender: 'enable' } },
    { title: '创建时间', dataIndex: 'created' },
    { title: '操作', scopedSlots: { customRender: 'action' }, width: 260 },
];

export default {
    components: {
        UserFormModal,
        UserTopUpModal,
        UserCashoutModal,
        UserResetPasswordModal,
        UserOddsDrawer,
    },
    data() {
        return {
            queryParams: {},
            tableLoading: false,
            tableColumns,
            tableData: [],
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            userFormVisible: false,
            userFormLoading: false,
            roleList: [],
            actionUser: null,
            topUpVisible: false,
            topUpLoading: false,
            cashOutVisible: false,
            cashOutLoading: false,
            resetPasswordVisible: false,
            resetPasswordLoading: false,
            oddsVisible: false,
            oddsUser: null,
        };
    },
    created() {
        this.fetchRoleOptions();
        this.getTableData();
    },
    methods: {
        isShareholder(record) {
            return Number(record.roleId) === ROLE_SHAREHOLDER;
        },
        isMember(record) {
            return Number(record.roleId) === ROLE_MEMBER;
        },
        openOddsDrawer(record) {
            this.oddsUser = record;
            this.oddsVisible = true;
        },
        fetchRoleOptions() {
            return userRoleList().then((res) => {
                this.roleList = res.data.roleList || [];
            });
        },
        getTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

            return userList(this.queryParams).then((res) => {
                this.tableData = res.data.recordList || [];
                this.totalRow = res.data.totalRow || 0;
            }).finally(() => {
                this.tableLoading = false;
            });
        },
        pageChange(current) {
            this.pageIndex = current;
            this.getTableData();
        },
        add() {
            this.userFormVisible = true;
        },
        userFormCancel() {
            this.userFormVisible = false;
        },
        userFormOk() {
            const modal = this.$refs.userForm;
            if (!modal || !modal.$refs.userForm) {
                return;
            }
            modal.$refs.userForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                this.userFormLoading = true;
                userAdd({ ...modal.form }).then(() => {
                    this.userFormVisible = false;
                    this.getTableData();
                    this.$message.success('新增用户成功');
                }).finally(() => {
                    this.userFormLoading = false;
                });
            });
        },
        toggleEnable(record) {
            const next = record.isEnable === 'Y' ? 'N' : 'Y';
            userSetEnable(record.id, next).then(() => {
                this.getTableData();
                this.$message.success(next === 'Y' ? '已启用' : '已禁用');
            });
        },
        toggleSpecial(record) {
            const next = record.isSpecial === 'Y' ? 'N' : 'Y';
            userSetSpecial(record.id, next).then(() => {
                this.getTableData();
                this.$message.success(next === 'Y' ? '已开启咪牌' : '已关闭咪牌');
            });
        },
        openTopUp(record) {
            this.actionUser = record;
            this.topUpVisible = true;
        },
        submitTopUp(form) {
            this.topUpLoading = true;
            userTopUp(form).then(() => {
                this.topUpVisible = false;
                this.getTableData();
                this.$message.success('上分成功');
            }).finally(() => {
                this.topUpLoading = false;
            });
        },
        openCashOut(record) {
            this.actionUser = record;
            this.cashOutVisible = true;
        },
        submitCashOut(form) {
            this.cashOutLoading = true;
            userCashOut(form).then(() => {
                this.cashOutVisible = false;
                this.getTableData();
                this.$message.success('下分成功');
            }).finally(() => {
                this.cashOutLoading = false;
            });
        },
        openResetPassword(record) {
            this.actionUser = record;
            this.resetPasswordVisible = true;
        },
        submitResetPassword(form) {
            this.resetPasswordLoading = true;
            userResetPassword(form).then(() => {
                this.resetPasswordVisible = false;
                this.$message.success('密码已重置');
            }).finally(() => {
                this.resetPasswordLoading = false;
            });
        },
        confirmDelUser(record) {
            const name = record.nickname || record.loginAccount || record.id;
            this.$confirm({
                title: '确定删除该会员？',
                content: `账号：${name}（ID:${record.id}），删除后不可恢复`,
                okText: '删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => userDel(record.id).then(() => {
                    this.getTableData();
                    this.$message.success('删除会员成功');
                }),
            });
        },
    },
};
</script>

<style lang="less" scoped>
.user {
    p {
        margin: 0;
    }

    p.user-extra {
        margin-top: 5px;
        font-size: 12px;
        color: #acacac;
    }
}

.user-sub {
    font-size: 12px;
    color: rgba(0, 0, 0, 0.45);
    margin-top: 4px;
}

.tag-role {
    color: #1890ff;
    margin-left: 4px;
}

.tag-special {
    color: #fa8c16;
    margin-left: 4px;
}
</style>
